import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';
import Icon from '@components/@core/Icon';
import Rating from '@components/@core/Rating';
import { convertUrl } from '~/services/util';

const ProductCard = ({ data, logo, onDetail }) => (
    <div className="product-card" onClick={onDetail}>
        <div className="logo">
            <Image className="w-100" src={convertUrl(logo, '/images/default_company.svg')} />
        </div>
        <div className="d-flex-1">
            <p className="dsl-b18 bold mb-2 word-break truncate-one">{data?.name}</p>
            <Rating score={Number(data?.stats?.rating_avg || 0)} />
            <p className="dsl-m14 mb-2">{Math.round(data?.stats?.rating_recommended_avg * 100) / 100}% Recommended</p>
            <p className="dsl-m12 mb-2">{data?.stats?.rating_count || 0} Reviews</p>
            {data?.data?.video && (
                <div className="d-flex">
                    <Icon name="fas fa-play me-2" color="#343f4b" size={12} />
                    <span className="dsl-b12">Video</span>
                </div>
            )}
        </div>
    </div>
);

ProductCard.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        stats: PropTypes.shape({
            likely: PropTypes.number,
            rating_avg: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            rating_count: PropTypes.number,
            rating_dealership_count: PropTypes.number,
            rating_recommended_avg: PropTypes.number,
        }),
        data: PropTypes.shape({
            video: PropTypes.bool,
        }),
    }),
    logo: PropTypes.string,
};

ProductCard.defaultProps = {
    data: {
        id: 1,
        name: '',
        stats: {
            likely: 0,
            rating_avg: 0,
            rating_count: 0,
            rating_dealership_count: 0,
            rating_recommended_avg: 0,
        },
        data: {
            video: false,
        },
    },
    logo: '/images/default_company.svg',
};

export default ProductCard;
